import { render, staticRenderFns } from "./xinlv.vue?vue&type=template&id=5e5fb4c6&scoped=true&"
import script from "./xinlv.vue?vue&type=script&lang=ts&"
export * from "./xinlv.vue?vue&type=script&lang=ts&"
import style0 from "./xinlv.vue?vue&type=style&index=0&id=5e5fb4c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5fb4c6",
  null
  
)

export default component.exports